<div
  class="person"
  [class.light]="light"
  [class.big]="big"
  [class.small]="small"
  [class.tiny]="tiny">
  <!-- Image -->
  @if (employee() || showPlaceholder) {
    <div
      class="avatar-container"
      [class.show-flag]="employee() && showFlag">
      <div
        slot="start"
        [class]="{ placeholder: showPlaceholder, avatar: true }">
        @if (imageIcon) {
          <mat-icon>{{ imageIcon }}</mat-icon>
        } @else {
          <!-- eslint-disable @angular-eslint/template/no-duplicate-attributes -->
          <coin-employee-picture
            background="none"
            size="medium"
            [size]="big ? 'large' : small ? 'small' : tiny ? 'tiny' : 'medium'"
            [gid]="employee()?.headGid || employee()?.gid"></coin-employee-picture>
        }
      </div>
      @if (employee()?.companyExitDate && showExitDateWarning) {
        <div
          class="exit-date-warning"
          [matTooltip]="'general.employee-exit-date-msg' | translate: { exitDate: formattedCompanyExitDate }">
          <mat-icon>event_busy</mat-icon>
        </div>
      }
    </div>
  }

  <div class="additional-icons">
    <mat-icon>chevron_right</mat-icon>
    @if (
      employee() &&
      showFlag &&
      (employee()?.countryCode || employee()?.placeOfAction || employee()['placeofAction'] || employee()?.country)
    ) {
      <coin-v2-country-flag
        class="flag-icon"
        size="s"
        [showTooltip]="true"
        [country]="employee() | pure: country"></coin-v2-country-flag>
    }
  </div>

  @if (!hideText) {
    <div class="infos">
      <!-- Top info -->
      @for (item of customTopInfo; track item) {
        <p
          coinEllipsisTooltip
          matTooltip
          class="additional-info">
          {{ item }}
        </p>
      }
      <!-- Employee name -->
      <div
        class="info-header"
        [ngClass]="{ 'single-line': singleLine || showPlaceholder }">
        @if (showPlaceholder) {
          <p>{{ placeholderText }}</p>
        } @else {
          @if (employee()) {
            @if (singleLine && showPreferredName === 'never') {
              <p
                coinEllipsisTooltip
                matTooltip
                [class.bold]="boldName"
                [ngClass]="{ smaller: noWrap }">
                {{ namePrefix }}{{ employee() | employeeName: showPreferredName }}
              </p>
            } @else {
              @if (namePrefix) {
                <p [class.bold]="boldName">{{ namePrefix }}</p>
              }
              <!-- only preferred if available -->
              @if (showPreferredName === 'ifAvailable') {
                <p
                  class="preferred-name"
                  [class.bold]="boldName">
                  {{ employee() | employeeName: showPreferredName }}
                </p>
              }
              <!-- preferred + fullname -->
              @if (showPreferredName === 'preferredAndFull') {
                <div class="preferred-name">
                  <p
                    class="preferred-name"
                    [class.bold]="boldName">
                    {{ employee() | employeeName: showPreferredName }}
                  </p>
                  @if ((employee()?.preferredFirstname || employee()?.preferredSurname) && (employee()?.firstname || employee()?.lastname)) {
                    <div class="sub-preferredname">
                      <p>({{ employee()?.firstname }} {{ employee()?.lastname }})</p>
                    </div>
                  }
                </div>
              }
              <!-- fullname -->
              @if (showPreferredName === 'never') {
                <p class="preferred-name">{{ employee() | employeeName: showPreferredName }}</p>
              }
            }
          }
        }
        @if (showActionButton) {
          <coin-icon-button
            type="outline"
            icon="person_add"
            (click)="onActionClick()"></coin-icon-button>
        }
      </div>

      <!-- Org code -->
      @if (showOrgCode) {
        @if (!employee()?.headGid && !employee()?.isHead && (employee()?.paOrgCode || employee()?.orgCode)) {
          <coin-c-input-overlay
            class="org-code"
            [isEditable]="isOrgCodeEditable"
            [ngClass]="{ smaller: noWrap, wrap }"
            [infoHeader]="'general.orgcode-update' | translate"
            [infoText]="'general.change-orgcode' | translate"
            [isSmall]="true"
            [value]="overwriteOrgCode ?? employee()?.paOrgCode ?? employee()?.orgCode"
            [choicesWithSearch]="true"
            [lazyLoadChoicesFn]="lazyLoadOrgCodesFn"
            (valueChanged)="orgCodeChanged.emit($event)"></coin-c-input-overlay>
        }
        @if (thirdLineTemplate) {
          <ng-container *ngTemplateOutlet="thirdLineTemplate; context: { employee: employee() }"></ng-container>
        }
        @if ((employee()?.headGid || employee()?.isHead) && employee()?.orgCode) {
          <coin-c-input-overlay
            class="org-code"
            [isEditable]="isOrgCodeEditable"
            [ngClass]="{ smaller: noWrap, wrap }"
            [infoHeader]="'general.orgcode-update' | translate"
            [infoText]="'general.change-orgcode' | translate"
            [isSmall]="true"
            [value]="overwriteOrgCode ?? employee()?.orgCode"
            [choicesWithSearch]="true"
            [lazyLoadChoicesFn]="lazyLoadOrgCodesFn"
            (valueChanged)="orgCodeChanged.emit($event)"></coin-c-input-overlay>
        }
      }
      <!-- Sub title -->
      @if (subTitle) {
        <p [ngClass]="{ smaller: noWrap }">
          {{ subTitle }}
        </p>
      }
      <!-- Gid -->
      @if (showGid && (employee()?.headGid || employee()?.gid)) {
        @if (thirdLineTemplate) {
          <ng-container *ngTemplateOutlet="thirdLineTemplate; context: { employee: employee() }"></ng-container>
        } @else {
          <p>{{ idKey }}: {{ employee()?.headGid || employee()?.gid }}</p>
        }
      }
      <!-- Sub info -->
      @for (item of customSubInfo; track item) {
        <p
          coinEllipsisTooltip
          matTooltip
          class="additional-info">
          {{ item }}
        </p>
      }
    </div>
  }

  <!-- Roles -->
  @if (roleNames.length) {
    <div class="user-roles">
      @for (name of roleNames; track name) {
        <p
          class="item-coin"
          matTooltip
          coinEllipsisTooltip>
          {{ name }}
        </p>
      }
    </div>
  }

  <!-- Position -->
  @if (positionClass) {
    <div
      class="position-class"
      [class.pc-small]="smallerPositionClass">
      <p>PC {{ positionClass }}</p>
    </div>
  }
  @if (!positionClass && showHintIfNoPositionClassSet) {
    <div
      class="position-class missing"
      [class.pc-small]="smallerPositionClass">
      <p>{{ 'mercer-support.dialog.no-pc' | translate }}</p>
    </div>
  }
</div>
